import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=61af67d9&scoped=true&"
import script from "./matching.vue?vue&type=script&lang=js&"
export * from "./matching.vue?vue&type=script&lang=js&"
import style0 from "./matching.vue?vue&type=style&index=0&id=61af67d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af67d9",
  null
  
)

export default component.exports